module.exports = __webpack_public_path__ + "img/img_hope01.6c138a97.webp";